import { userService } from './../../../Services/userService';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Component, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MotorProposal } from '../../../Models/MotorProposal';
import { BindMdl } from '../../../Models/BindMdl';
import { restURL } from '../../../Models/restURL';
import { motorProposalService } from '../../../Services/motorProposalService';
import { MotorDriverMdl } from '../../../Models/MotorDriverMdl';
import { DriverLicenceReq, DriverLicenceRes } from '../../../Models/DriverLicenceReq';
import { LanguageService } from '../../../Services/languageService';
import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
import { mdlDriverInfoReq } from '../../../Models/mdlDriverInfoReq';
import { mdlDriverInfoRes } from '../../../Models/mdlDriverInfoRes';
import Swal from 'sweetalert2';
import { now } from 'moment';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'DriverInfo',
  templateUrl: './DriverInfo.html',
  styleUrls: ['./DriverInfo.css']
})
export class DriverInfo implements OnDestroy {

  //public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public prObj: MotorProposal = new MotorProposal();
  public bindObj: BindMdl = new BindMdl();
  public subscription: Subscription;
  public bindSubscription: Subscription;
  public diverObj: MotorDriverMdl = new MotorDriverMdl();
  public DriverId: string;
  public DriverMM: string;
  public DriverDD: string;
  public DriverYY: string;
  public isShowLoading: boolean;
  public DriverLicExpYY: string;
  public DriverLicExpMM: string;
  public DriverLicExpDD: string;

  public driverLicReq: DriverLicenceReq = new DriverLicenceReq();
  public driverLicRes: DriverLicenceRes = new DriverLicenceRes();
  public objmdlDriverInfoReq: mdlDriverInfoReq = new mdlDriverInfoReq();
  public objmdlDriverInfoRes: mdlDriverInfoRes = new mdlDriverInfoRes();
  public LngSubscription: Subscription;
  public Lng: string;
  public isSearchSubmitted: boolean = false;
  public isDriverSubmitted: boolean = false;
  public isError: boolean = false;
  public ErrorMsg: string = "";
  public ErrorYear: boolean = false;

  public isGregorian: boolean = false;
  public NoLicenseExpDate: boolean;
  public DriverLic_ExpiryDate_Long: Date;
  public Mindate: Date = new Date;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

  @ViewChild('closeBtn') closeBtn: ElementRef;
  constructor(public Translate: TranslateService,private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private lngService: LanguageService, private proposalService: motorProposalService, private trackingObj: MotorproposalTrackingService, private userinfo: userService) {

    this.prObj = this.proposalService.getProposalObj();
    this.bindObj = this.proposalService.getBindObj();
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    this.isError = false;
    this.ErrorMsg = "";
    this.NoLicenseExpDate = false;
    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }



    this.driverLicRes.st.StatusCode = "F";
    this.diverObj.DriverCity = "0";
    this.diverObj.DriverEducation = "5";
    this.diverObj.DriverProfession = "1";
    this.diverObj.OtherCountriesLicenceHeld = "0";
    this.diverObj.DriverMedicalConditions = "1";
    this.diverObj.DriverMaritalStatus = "0";
    this.diverObj.DriverNationality = "0";
    this.diverObj.Ismaindriver = "1";
    this.diverObj.Drivergender = "0";
    this.diverObj.RelationWithInsured = "0";
    this.diverObj.RoadConvictions = 74;
    this.diverObj.DriverChildrenYears = "1";
    this.diverObj.SaudiLicenceHeld = "0";
    this.diverObj.OtherCountriesLicenceHeld = "341";
    this.diverObj.NumberOfYearsEachCountry = "1";
    this.diverObj.DriverMedicalConditions = "7";
    this.diverObj.OfficeCity = 0;


  }
  ngOnDestroy() {
  }

  CheckYear(value) {
    var CurrentYear = new Date().getFullYear();
    if (value < CurrentYear) {
      this.ErrorYear = true;
      this.NoLicenseExpDate = false;
    } else {
      this.ErrorYear = false;

    }
  }
  DriverSearch(valid) {
    this.isSearchSubmitted = true;

    let DriverCount: number = 0;
    DriverCount = this.prObj.driverListObj.length;
    let DriverLimit: number = 3;
    DriverLimit = this.prObj.DriverMaxLimit;

    if (DriverCount >= DriverLimit) {
      this.Lng == "ar" ? Swal("لا يمكنك إضافة أكثر من ثلاثة سائقين ") : Swal("You can't add more than " + DriverLimit + " drivers")
      return;
    }

    let DriverLicCount: number = 0;
    this.isError = false;
    this.ErrorMsg = "";
    DriverLicCount = this.prObj.driverListObj.filter(t => t.DriverLicenseNo == this.DriverId).length;

    if (DriverLicCount > 0) {
      this.Lng == "ar" ? Swal("بيانات السائق موجودة مسبقا") : Swal("Driver Licence No Already Existed");
      return;
    }

    if (valid) {

      this.objmdlDriverInfoReq.DriverId = this.DriverId;
      if (this.DriverId.startsWith("1")) {
        this.objmdlDriverInfoReq.IdExpiry = this.DriverMM + "-" + this.DriverYY;
        this.objmdlDriverInfoReq.DOB = '';
      }
      else {
        this.objmdlDriverInfoReq.DOB = this.DriverMM + "-" + this.DriverYY;
        this.objmdlDriverInfoReq.IdExpiry = '';
      }
      this.isShowLoading = true;

      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlDriverInfoReq));

      //this.http.post<mdlDriverInfoRes>(this.url.baseURL + "/DriverInfo/GetDriverInfo_New", this.objmdlDriverInfoReq, this.userinfo.getHttpOptions())
      this.http.post<mdlPayloadResponse>(this.url.baseURL + "/DriverInfo/GetDriverInfo_New", this.objPayloadRequest, this.userinfo.getHttpOptions())
        .toPromise().then((result) => {
          //this.objmdlDriverInfoRes = result;

          //New Line Start
          this.objPayloadResponse = result;
          this.objmdlDriverInfoRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
          //NewLine End

          this.isShowLoading = false;
          if (this.objmdlDriverInfoRes.Status.StatusCode == "F") {
           // Swal(this.objmdlDriverInfoRes.Status.StatusDecEn);
            Swal(this.Translate.instant(this.objmdlDriverInfoRes.Status.StatusDecEn))

          }
          else {
            this.diverObj.DriverNameAr = this.objmdlDriverInfoRes.ArabicFullName;
            this.diverObj.DriverNameEn = this.objmdlDriverInfoRes.EnglishFullName;
            this.diverObj.DriverLic_ExpiryDate = '';
            this.diverObj.DriverNationality = this.objmdlDriverInfoRes.NationalityCode;
            this.diverObj.DriverLicenseNo = this.objmdlDriverInfoReq.DriverId;
            this.diverObj.DriverDOB = this.objmdlDriverInfoRes.DateOfBirth;

            this.diverObj.DriverCity = this.objmdlDriverInfoRes.IDCityCode;
            this.diverObj.DriverMaritalStatus=this.objmdlDriverInfoRes.DriverMaritalStatus;
            if (this.diverObj.DriverCity != null) {
              this.ResCityChange(this.diverObj.DriverCity);
            }
            else {
              this.diverObj.DriverCity = "0";
            }

            this.diverObj.Driver_Age = this.objmdlDriverInfoRes.DriverAge;
            if (this.objmdlDriverInfoRes.Gender != null) {
              this.diverObj.Drivergender = this.objmdlDriverInfoRes.Gender == "M" ? "1" : "2";
            }

            if (Number(this.diverObj.Driver_Age) < 17 || Number(this.diverObj.Driver_Age) > 100) {
              //this.isError = true;
              //this.ErrorMsg = "Driver Age must be between 17 and 100 only"
              this.Lng == "ar" ? Swal("يجب أن يكون عمر السائق بين 17 و 100 عام") : Swal("Driver Age must be between 17 and 100 only");
              this.diverObj.DriverNationality = '';
              this.diverObj.DriverLicenseNo = '';
              this.DriverId = '';
              this.DriverMM = '';
              this.DriverYY = ''
              this.diverObj.DriverCity = '';
              this.diverObj.DriverNameAr = "";
              this.diverObj.DriverNameEn = "";
              this.closeBtn.nativeElement.click();
            }
            else {
              this.isError = false;
              this.ErrorMsg = "";
              if (Number(this.diverObj.Driver_Age) < 25) {
                this.diverObj.DriverLicenseType = "8";
              }
              else {
                this.diverObj.DriverLicenseType = "9";
              }

            }
          }

        },
          (error) => {
            this.isShowLoading = false;
            this.userinfo.checkTokenStatus(error);

          });

    }
  }

  SetDOBType(ID) {
    var IDType: string;
    IDType = ID;
    if (IDType != "") {
      if (IDType.charAt(0) == "1") {
        this.isGregorian = false;
      }
      else {
        this.isGregorian = true;
      }
    }
  }

  
  AddNewDriver(valid) {
    if (!valid) {
      this.isDriverSubmitted = true;
      return;
    }
    this.isDriverSubmitted = true;
    if (this.ErrorYear) {
      return;
    }

    if (valid) {

      let newDriverObj: MotorDriverMdl = new MotorDriverMdl();
      let DriverLicCount: number = 0;
      let DriverCount: number = 0;
      let mainDriverCount: number = 0;

      let DriverLimit: number = 3;
      DriverLimit = this.prObj.DriverMaxLimit;
      // let Day:number=0;
      // let Month:string='';
      // let Year:string='';
      // Day=this.DriverLic_ExpiryDate_Long.getDay();
      //this.diverObj.DriverLic_ExpiryDate = this.DriverLicExpDD+"-"+this.DriverLicExpMM+"-"+this.DriverLicExpYY ;
      // this.diverObj.DriverLic_ExpiryDate = this.diverObj.DriverLicYY+"-"+this.diverObj.DriverLicMM+"-"+this.diverObj.DriverLicDD;

     let DrivePer:number=0;
     DrivePer=this.prObj.driverListObj.reduce(  (a: number, b) => a + Number(b.DriverUsagePercentage), 0); 
     DrivePer=Number(DrivePer)+ Number(this.diverObj.DriverUsagePercentage);

     if(DrivePer>100)
     {
      Swal("Maximum Total Driver Usage Percenatege is 100%");
      return;
     } 
      DriverCount = this.prObj.driverListObj.length;
      if (DriverCount > DriverLimit) {
        this.Lng == "ar" ? Swal("لا يمكنك إضافة أكثر من ثلاثة سائقين ") : Swal("You can't add more than " + DriverLimit + " drivers");
      }
      else {
        DriverLicCount = this.prObj.driverListObj.filter(t => t.DriverLicenseNo == this.diverObj.DriverLicenseNo).length;
        if (DriverLicCount == 0) {
          if (this.diverObj.Ismaindriver == "1") {
            mainDriverCount = this.prObj.driverListObj.filter(t => t.Ismaindriver == "1").length;
          }
          if (mainDriverCount > 0) {
            this.Lng == "ar" ? Swal(" يسمح بإضافة سائق رئيسي واحد فقط ") : Swal("Only one main Driver is allowed to add");

          }
          else {
            newDriverObj.Ismaindriver = this.diverObj.Ismaindriver;
            newDriverObj.DriverLicenseNo = this.diverObj.DriverLicenseNo;
            newDriverObj.DriverDOB = this.diverObj.DriverDOB;

            if (this.diverObj.Ismaindriver == "1") {
              newDriverObj.isMainDriverEn = "Yes";
              newDriverObj.isMainDriverEn = "Yes";
            }
            else if (this.diverObj.Ismaindriver == "2") {
              newDriverObj.isMainDriverEn = "No";
              newDriverObj.isMainDriverEn = "No";
            }
            else {
              this.Lng == "ar" ? Swal("الرجاء اختيار هل سائق رئيسي ") : Swal("Please select  Main Driver Field");
              return;
            }
            newDriverObj.DriverNameAr = this.diverObj.DriverNameAr;
            newDriverObj.DriverNameEn = this.diverObj.DriverNameEn;
            newDriverObj.DriverLic_ExpiryDate = this.diverObj.DriverLic_ExpiryDate;
            newDriverObj.DriverNationalityEn = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.diverObj.DriverNationality)[0].NationalityDescEn;
            newDriverObj.DriverNationalityAr = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.diverObj.DriverNationality)[0].NationalityDescAr;
            newDriverObj.DriverNationality = this.diverObj.DriverNationality;
            newDriverObj.DriverLicenseTypeEn = this.bindObj.LicenceTypeList.filter(t => t.LicTypecode == Number(this.diverObj.DriverLicenseType))[0].LicType_DescEn;
            newDriverObj.DriverLicenseTypeAr = this.bindObj.LicenceTypeList.filter(t => t.LicTypecode == Number(this.diverObj.DriverLicenseType))[0].LicType_DescAr;
            newDriverObj.DriverLicenseType = this.diverObj.DriverLicenseType;
            newDriverObj.DriverMaritalStatusEn = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.diverObj.DriverMaritalStatus)[0].MarstatusDesc_En;
            newDriverObj.DriverMaritalStatusAr = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.diverObj.DriverMaritalStatus)[0].MarstatusDesc_Ar;
            newDriverObj.DriverMaritalStatus = this.diverObj.DriverMaritalStatus;
            newDriverObj.DriverCity = this.diverObj.DriverCity;
            newDriverObj.DriverEducation = this.diverObj.DriverEducation;
            newDriverObj.SaudiLicenceHeld = this.diverObj.SaudiLicenceHeld;
            newDriverObj.DriverProfession = this.diverObj.DriverProfession;
            newDriverObj.DriverChildrenYears = this.diverObj.DriverChildrenYears;
            newDriverObj.OtherCountriesLicenceHeld = this.diverObj.OtherCountriesLicenceHeld;
            newDriverObj.NumberOfYearsEachCountry = this.diverObj.NumberOfYearsEachCountry;
            newDriverObj.DriverMedicalConditions = this.diverObj.DriverMedicalConditions;
            newDriverObj.DriverAddress = this.diverObj.DriverAddress;
            newDriverObj.Drivergender = this.diverObj.Drivergender;
            newDriverObj.RelationWithInsured = this.diverObj.RelationWithInsured;
            newDriverObj.Driver_Age = this.diverObj.Driver_Age;

            newDriverObj.ResidenceAdditionalNumber = this.diverObj.ResidenceAdditionalNumber;
            newDriverObj.ResidenceBuildingNumber = this.diverObj.ResidenceBuildingNumber;
            newDriverObj.ResidenceCity = Number(this.diverObj.DriverCity);
            newDriverObj.ResidenceDistrict = this.diverObj.ResidenceDistrict;
            newDriverObj.ResidenceStreet = this.diverObj.ResidenceStreet;
            newDriverObj.ResidenceUnitNumber = this.diverObj.ResidenceUnitNumber;
            newDriverObj.ResidenceZipCode = this.diverObj.ResidenceZipCode;
            newDriverObj.ResidenceZone = this.diverObj.ResidenceZone;

            newDriverObj.OfficeBuildingNumber = this.diverObj.OfficeBuildingNumber;
            newDriverObj.OfficeCity = this.diverObj.OfficeCity;
            newDriverObj.OfficeDistrict = this.diverObj.OfficeDistrict;
            newDriverObj.OfficeStreet = this.diverObj.OfficeStreet;
            newDriverObj.OfficeUnitNumber = this.diverObj.OfficeUnitNumber;
            newDriverObj.OfficeZipCode = this.diverObj.OfficeZipCode;
            newDriverObj.OfficeZone = this.diverObj.OfficeZone;
            newDriverObj.OfficeAdditionalNumber = this.diverObj.OfficeAdditionalNumber;
            newDriverObj.RoadConvictions = this.diverObj.RoadConvictions;
            newDriverObj.DriverUsagePercentage=this.diverObj.DriverUsagePercentage;


            if (this.diverObj.DriverLicenseNo) {
              if (this.diverObj.DriverLicenseNo.startsWith("1")) {
                newDriverObj.DriverIDType = "1";
              }
              else {
                newDriverObj.DriverIDType = "2";
              }
            }

            if (this.Lng == "en") {
              newDriverObj.LangFlag = "E";
            }
            else {
              newDriverObj.LangFlag = "A";
            }

            this.prObj.driverListObj.push(newDriverObj);
            this.Lng == "ar" ? Swal("تمت إضافة بيانات السائق بنجاح") : Swal("Driver added successfully");

            this.diverObj.Ismaindriver = "1";
            this.diverObj.DriverLicenseNo = "";
            this.diverObj.DriverDOB = "";
            this.diverObj.DriverNameAr = "";
            this.diverObj.DriverNameEn = "";
            this.diverObj.DriverLic_ExpiryDate = "";

            this.diverObj.DriverAddress = "";
            this.diverObj.Drivergender = "0";
            this.diverObj.RelationWithInsured = "0";
            this.diverObj.DriverNationality = "0";
            this.diverObj.DriverLicenseType = "0";
            this.diverObj.Driver_Age = "0";
            this.DriverId = "";
            this.DriverDD = "";
            this.DriverMM = "";
            this.DriverYY = "";
            this.DriverLicExpDD = "";
            this.DriverLicExpMM = "";
            this.DriverLicExpYY = "";
            this.DriverLic_ExpiryDate_Long = null;
            this.diverObj.DriverMaritalStatus = '0';

            this.diverObj.ResidenceAdditionalNumber = null;
            this.diverObj.ResidenceBuildingNumber = null;
            this.diverObj.DriverCity = "0";
            this.diverObj.ResidenceDistrict = "";
            this.diverObj.ResidenceStreet = "";
            this.diverObj.ResidenceUnitNumber = null;
            this.diverObj.ResidenceZipCode = null;
            this.diverObj.ResidenceZone = "";


            this.diverObj.OfficeAdditionalNumber = null;
            this.diverObj.OfficeBuildingNumber = null;
            this.diverObj.OfficeCity = 0
            this.diverObj.OfficeDistrict = "";
            this.diverObj.OfficeStreet = "";
            this.diverObj.OfficeUnitNumber = null;
            this.diverObj.OfficeZipCode = null;
            this.diverObj.OfficeZone = "";


            this.diverObj.DriverEducation = "5";
            this.diverObj.SaudiLicenceHeld = "0";
            this.diverObj.DriverProfession = "1";
            this.diverObj.OtherCountriesLicenceHeld = "341";
            this.diverObj.DriverMedicalConditions = "7";
            this.diverObj.RoadConvictions = 74;
            this.diverObj.DriverChildrenYears = "1";
            this.diverObj.NumberOfYearsEachCountry = "1";


            this.closeBtn.nativeElement.click();


          }
        }
        else {
          this.Lng == "ar" ? Swal("بيانات السائق موجودة مسبقا") : Swal("Driver Licence No Already Existed");
        }
      }
    }


  }
  removeDriver(index) {
    this.prObj.driverListObj.splice(index, 1);
  }


  goPrev() {
    if (this.prObj.st.StatusCode == "F") {
      this.prObj.st.StatusCode = "";
    }
    if (this.prObj.driverListObj.length <= 0) {
      sessionStorage.setItem("NoDriver", "Y");
    }
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    sessionStorage.setItem("CurrentRoute", "InsuredInfo");
    this.router.navigate(['NewDashboard/MotorProposalForm/InsuredInfo']);

  }


  countMainDrivers(): number {
    let mainDriverCount: number = 0;

    mainDriverCount = this.prObj.driverListObj.filter(t => t.Ismaindriver == "1").length;

    return mainDriverCount;
  }


  public CalculateAge(DD, MM, YYYY): number {
    var dage: number;
    var todayDate = new Date(),
      todayYear = todayDate.getFullYear(),
      todayMonth = todayDate.getMonth(),
      todayDay = todayDate.getDate(),
      dage = todayYear - YYYY;

    if (todayMonth < MM.date - 1) {
      dage--;
    }

    if (MM.date - 1 === todayMonth && todayDay < DD.date) {
      dage--;
    }
    return dage;
  }


  GoNext() {
    let DriverLimit: number = 3;
    DriverLimit = this.prObj.DriverMaxLimit;
    if (this.prObj.driverListObj.length > 0) {

      if (this.prObj.driverListObj.length > DriverLimit) {
        this.Lng == "ar" ? this.ErrorMsg = "لا يمكنك إضافة أكثر من ثلاثة سائقين" : this.ErrorMsg = "You can not add more than " + DriverLimit + " drivers";
        this.isError = true;
      }
      else {

        if (this.countMainDrivers() > 0) {

          if (this.prObj.isInsuredMainDriver && this.prObj.driverListObj.length == 1) {
            this.Lng == "ar" ? this.ErrorMsg = "يرجى إضافة واحد على الأقل سائق واحد غير السائق الرئيسي للمضي قدما" : this.ErrorMsg = "Please Add atleast one driver other than main driver to proceed further";
            this.isError = true;
            return;
          }
          this.ErrorMsg = "";
          this.isError = false;
          if (this.prObj.isEditProposal == false) {
            this.prObj.trackingObj.ScreenNo = "D";
            this.trackingObj.saveTrackStatus(this.prObj)
          }
          sessionStorage.setItem("CurrentRoute", "PremiumInfo");
          this.proposalService.saveProposalObj(this.prObj);
          this.proposalService.saveBindObj(this.bindObj);
          this.router.navigate(['NewDashboard/MotorProposalForm/PremiumInfo']);


        }
        else {
          this.Lng == "ar" ? this.ErrorMsg = "الرجاء إضافة  سائق رئيسي واحد على الأقل للمتابعة" : this.ErrorMsg = "Please Add atleast one  main driver to proceed further";
          this.isError = true;
        }
      }
    }
    else {
      this.Lng == "ar" ? this.ErrorMsg = "الرجاء إضافة سائق رئيسي واحد على الأقل للمتابعة" : this.ErrorMsg = "Please Add atleast one  main driver to proceed further";
      this.isError = true;
    }
  }


  CheckLicenseExpiry() {
    let CurrentDate: Date;
    CurrentDate = new Date();
    if (this.DriverLic_ExpiryDate_Long < CurrentDate) {
      this.DriverLic_ExpiryDate_Long = null;
      this.Lng == "en" ? Swal("License Expiry Date Must be Greater than Current Date") : Swal("License Expiry Date Must be Greater than Current Date");
    }


  }
  ValidateYear(val) {
    if (val < 1400 || val > 1522) {
      this.ErrorYear = true;
    } else {
      this.ErrorYear = false;
    }
  }

  ValidateSpecialChar(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  OfficeCityChange(val) {
    this.diverObj.OfficeZone = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
  }

  ResCityChange(val) {
    this.diverObj.ResidenceZone = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
  }



}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/DriverInfo/DriverInfo.ts